
export const TimezoneValues = [
    {
    gmt: "-11:00",
    city: "",
    country: "",
    continent: "Pacific",
    location: "TIMEZONE.MIDWAY_ISLAND",
    i18n: "TIMEZONE.MIDWAY_ISLAND",
    area: "",
    bc_id: "1",
    canonical_id: "Pacific/Midway"
    },
	{
	gmt: "-10:00",
	city: "",
	country: "",
	continent: "Pacific",
	location: "TIMEZONE.HAWAII",
	i18n: "TIMEZONE.HAWAII",
	area: "",
	bc_id: "2",
	canonical_id: "Pacific/Honolulu"
	},
	{
	gmt: "-09:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.ALASKA",
	i18n: "TIMEZONE.ALASKA",
	area: "",
	bc_id: "3",
	canonical_id: "America/Anchorage"
	},
	{
	gmt: "-08:00",
	city: "",
	country: "",
	continent: "Pacific",
	location: "TIMEZONE.PACIFIC_TIME",
	i18n: "TIMEZONE.PACIFIC_TIME",
	area: "pacific standard time",
	bc_id: "5",
	canonical_id: "Etc/GMT+8"
	},
	{
	gmt: "-08:00",
	city: "tijuana",
	country: "",
	continent: "America",
	location: "TIMEZONE.TIJUANA_BAJA_CALIFORNIA",
	i18n: "TIMEZONE.TIJUANA_BAJA_CALIFORNIA",
	area: "",
	bc_id: "4",
	canonical_id: "America/Tijuana"
	},
	{
	gmt: "-07:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.MOUNTAIN_TIME",
	i18n: "TIMEZONE.MOUNTAIN_TIME",
	area: "us mountain standard time",
	bc_id: "6",
	canonical_id: "America/Edmonton"
	},
	{
	gmt: "-07:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.CHIHUAHUA_LA_PAZ_MAZATLAN",
	i18n: "TIMEZONE.CHIHUAHUA_LA_PAZ_MAZATLAN",
	area: "mexico standard time 2",
	bc_id: "7",
	canonical_id: "America/Chihuahua"
	},
	{
	gmt: "-07:00",
	city: "",
	country: "arizona",
	continent: "America",
	location: "TIMEZONE.ARIZONA",
	i18n: "TIMEZONE.ARIZONA",
	area: "us mountain standard time",
	bc_id: "9",
	canonical_id: "America/Phoenix"
	},
	{
	gmt: "-06:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.CENTRAL_TIME",
	i18n: "TIMEZONE.CENTRAL_TIME",
	area: "",
	bc_id: "13",
	canonical_id: "America/Winnipeg"
	},
	{
	gmt: "-06:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.SASKATCHEWAN",
	i18n: "TIMEZONE.SASKATCHEWAN",
	area: "canada central standard time",
	bc_id: "10",
	canonical_id: "America/Regina"
	},
	{
	gmt: "-06:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.GUADALAJARA_MEXICO_CITY_MONTERREY",
	i18n: "TIMEZONE.GUADALAJARA_MEXICO_CITY_MONTERREY",
	area: "",
	bc_id: "11",
	canonical_id: "America/Monterrey"
	},
	{
	gmt: "-06:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.CENTRAL_AMERICA",
	i18n: "TIMEZONE.CENTRAL_AMERICA",
	area: "central america standard time",
	bc_id: "14",
	canonical_id: "America/Winnipeg"
	},
	{
	gmt: "-05:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.EASTERN_TIME",
	i18n: "TIMEZONE.EASTERN_TIME",
	area: "",
	bc_id: "16",
	canonical_id: "America/New_York"
	},
	{
	gmt: "-05:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.INDIANA",
	i18n: "TIMEZONE.INDIANA",
	area: "us eastern standard time",
	bc_id: "15",
	canonical_id: "America/Indiana/Indianapolis"
	},
	{
	gmt: "-05:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.BOGOTA_LIMA_QUITO_RIO_BRANCO",
	i18n: "TIMEZONE.BOGOTA_LIMA_QUITO_RIO_BRANCO",
	area: "sa pacific standard time",
	bc_id: "17",
	canonical_id: "America/Bogota"
	},
	{
	gmt: "-04:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.CARACAS",
	i18n: "TIMEZONE.CARACAS",
	area: "",
	bc_id: "18",
	canonical_id: "America/Caracas"
	},
	{
	gmt: "-04:00",
	city: "",
	country: "",
	continent: "Atlantic",
	location: "TIMEZONE.ATLANTIC_TIME",
	i18n: "TIMEZONE.ATLANTIC_TIME",
	area: "atlantic standard time",
	bc_id: "22",
	canonical_id: "America/Halifax"
	},
	{
	gmt: "-04:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.SANTIAGO",
	i18n: "TIMEZONE.SANTIAGO",
	area: "",
	bc_id: "19",
	canonical_id: "America/Santiago"
	},
	{
	gmt: "-04:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.GEORGETOWN_MANAUS",
	i18n: "TIMEZONE.GEORGETOWN_MANAUS",
	area: "",
	bc_id: "20",
	canonical_id: "America/Manaus"
	},
	{
	gmt: "-04:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.LA_PAZ",
	i18n: "TIMEZONE.LA_PAZ",
	area: "sa western standard time",
	bc_id: "21",
	canonical_id: "America/La_Paz"
	},
	{
	gmt: "-03:30",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.NEWFOUNDLAND",
	i18n: "TIMEZONE.NEWFOUNDLAND",
	area: "",
	bc_id: "23",
	canonical_id: "America/St_Johns"
	},
	{
	gmt: "-03:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.BUENOS_AIRES",
	i18n: "TIMEZONE.BUENOS_AIRES",
	area: "",
	bc_id: "27",
	canonical_id: "America/Argentina/Buenos_Aires"
	},
	{
	gmt: "-03:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.MONTEVIDEO",
	i18n: "TIMEZONE.MONTEVIDEO",
	area: "",
	bc_id: "24",
	canonical_id: "America/Montevideo"
	},
	{
	gmt: "-03:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.GREENLAND",
	i18n: "TIMEZONE.GREENLAND",
	area: "",
	bc_id: "25",
	canonical_id: "Etc/GMT+3"
	},
	{
	gmt: "-03:00",
	city: "",
	country: "",
	continent: "America",
	location: "TIMEZONE.BRASILIA",
	i18n: "TIMEZONE.BRASILIA",
	area: "",
	bc_id: "28",
	canonical_id: "America/Sao_Paulo"
	},
	{
	gmt: "-02:00",
	city: "",
	country: "",
	continent: "Atlantic",
	location: "TIMEZONE.MIDATLANTIC",
	i18n: "TIMEZONE.MIDATLANTIC",
	area: "",
	bc_id: "29",
	canonical_id: "Atlantic/South_Georgia"
	},
	{
	gmt: "-01:00",
	city: "",
	country: "",
	continent: "Atlantic",
	location: "TIMEZONE.CAPE_VERDE_IS",
	i18n: "TIMEZONE.CAPE_VERDE_IS",
	area: "",
	bc_id: "30",
	canonical_id: "Atlantic/Cape_Verde"
	},
	{
	gmt: "-01:00",
	city: "",
	country: "",
	continent: "Atlantic",
	location: "TIMEZONE.AZORES",
	i18n: "TIMEZONE.AZORES",
	area: "",
	bc_id: "31",
	canonical_id: "Atlantic/Azores"
	},
	{
	gmt: "",
	city: "",
	country: "",
	continent: "Africa",
	location: "TIMEZONE.CASABLANCA",
	i18n: "TIMEZONE.CASABLANCA",
	area: "",
	bc_id: "32",
	canonical_id: "Africa/Casablanca"
	},
	{
	gmt: "",
	city: "",
	country: "",
	continent: "Europe",
	location: "TIMEZONE.GREENWICH_MEAN_TIME_DUBLIN_EDINBURGH_LISBON_LONDON",
	i18n: "TIMEZONE.GREENWICH_MEAN_TIME_DUBLIN_EDINBURGH_LISBON_LONDON",
	area: "",
	bc_id: "33",
	canonical_id: "Etc/GMT"
	},
	{
	gmt: "",
	city: "",
	country: "",
	continent: "Africa",
	location: "TIMEZONE.MONROVIA_REYKJAVIK",
	i18n: "TIMEZONE.MONROVIA_REYKJAVIK",
	area: "",
	bc_id: "34",
	canonical_id: "Africa/Monrovia"
	},
	{
	gmt: "+01:00",
	city: "",
	country: "",
	continent: "Europe",
	location: "TIMEZONE.AMSTERDAM_BERLIN_BERN_ROME_STOCKHOLM_VIENNA",
	i18n: "TIMEZONE.AMSTERDAM_BERLIN_BERN_ROME_STOCKHOLM_VIENNA",
	area: "",
	bc_id: "35",
	canonical_id: "Europe/Amsterdam"
	},
	{
	gmt: "+01:00",
	city: "",
	country: "",
	continent: "Europe",
	location: "TIMEZONE.BELGRADE_BRATISLAVA_BUDAPEST_LJUBLJANA_PRAGUE",
	i18n: "TIMEZONE.BELGRADE_BRATISLAVA_BUDAPEST_LJUBLJANA_PRAGUE",
	area: "",
	bc_id: "36",
	canonical_id: "Europe/Belgrade"
	},
	{
	gmt: "+01:00",
	city: "",
	country: "",
	continent: "Europe",
	location: "TIMEZONE.BRUSSELS_COPENHAGEN_MADRID_PARIS",
	i18n: "TIMEZONE.BRUSSELS_COPENHAGEN_MADRID_PARIS",
	area: "",
	bc_id: "37",
	canonical_id: "Europe/Brussels"
	},
	{
	gmt: "+01:00",
	city: "",
	country: "",
	continent: "Europe",
	location: "TIMEZONE.SARAJEVO_SKOPJE_WARSAW_ZAGREB",
	i18n: "TIMEZONE.SARAJEVO_SKOPJE_WARSAW_ZAGREB",
	area: "",
	bc_id: "38",
	canonical_id: "Europe/Belgrade"
	},
	{
	gmt: "+01:00",
	city: "",
	country: "",
	continent: "Africa",
	location: "TIMEZONE.WEST_CENTRAL_AFRICA",
	i18n: "TIMEZONE.WEST_CENTRAL_AFRICA",
	area: "",
	bc_id: "39",
	canonical_id: "Africa/Ouagadougou"
	},
	{
	gmt: "+01:00",
	city: "windhoek",
	country: "namibia",
	continent: "Africa",
	location: "TIMEZONE.WINDHOEK",
	i18n: "TIMEZONE.WINDHOEK",
	area: "",
	bc_id: "48",
	canonical_id: "Africa/Windhoek"
	},
	{
	gmt: "+02:00",
	city: "jerusalem",
	country: "israel",
	continent: "Asia",
	location: "TIMEZONE.JERUSALEM",
	i18n: "TIMEZONE.JERUSALEM",
	area: "",
	bc_id: "46",
	canonical_id: "Asia/Jerusalem"
	},
	{
	gmt: "+02:00",
	city: "amman",
	country: "jordan",
	continent: "Asia",
	location: "TIMEZONE.AMMAN",
	i18n: "TIMEZONE.AMMAN",
	area: "",
	bc_id: "40",
	canonical_id: "Asia/Amman"
	},
	{
	gmt: "+02:00",
	city: "athens",
	country: "greece",
	continent: "Europe",
	location: "TIMEZONE.ATHENS_BUCHAREST_ISTANBUL",
	i18n: "TIMEZONE.ATHENS_BUCHAREST_ISTANBUL",
	area: "gtb",
	bc_id: "41",
	canonical_id: "Europe/Athens"
	},
	{
	gmt: "+02:00",
	city: "beirut",
	country: "lebanon",
	continent: "Asia",
	location: "TIMEZONE.BEIRUT",
	i18n: "TIMEZONE.BEIRUT",
	area: "middle east standard time",
	bc_id: "42",
	canonical_id: "Asia/Beirut"
	},
	{
	gmt: "+02:00",
	city: "cairo",
	country: "egypt",
	continent: "Africa",
	location: "TIMEZONE.CAIRO",
	i18n: "TIMEZONE.CAIRO",
	area: "",
	bc_id: "43",
	canonical_id: "Africa/Cairo"
	},
	{
	gmt: "+02:00",
	city: "harare",
	country: "zimbabwe",
	continent: "Africa",
	location: "TIMEZONE.HARARE_PRETORIA",
	i18n: "TIMEZONE.HARARE_PRETORIA",
	area: "south africa standard time",
	bc_id: "44",
	canonical_id: "Africa/Harare"
	},
	{
	gmt: "+02:00",
	city: "helsinki",
	country: "finland",
	continent: "Europe",
	location: "TIMEZONE.HELSINKI_KYIV_RIGA_SOFIA_TALLINN_VILNIUS",
	i18n: "TIMEZONE.HELSINKI_KYIV_RIGA_SOFIA_TALLINN_VILNIUS",
	area: "fle standard time",
	bc_id: "45",
	canonical_id: "Europe/Helsinki"
	},
	{
	gmt: "+03:00",
	city: "minsk",
	country: "belarus",
	continent: "Europe",
	location: "TIMEZONE.MINSK",
	i18n: "TIMEZONE.MINSK",
	area: "",
	bc_id: "47",
	canonical_id: "Europe/Minsk"
	},
	{
	gmt: "+03:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.BAGHDAD",
	i18n: "TIMEZONE.BAGHDAD",
	area: "",
	bc_id: "49",
	canonical_id: "Asia/Baghdad"
	},
	{
	gmt: "+03:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.KUWAIT_RIYADH",
	i18n: "TIMEZONE.KUWAIT_RIYADH",
	area: "",
	bc_id: "50",
	canonical_id: "Asia/Kuwait"
	},
	{
	gmt: "+03:00",
	city: "",
	country: "",
	continent: "Africa",
	location: "TIMEZONE.NAIROBI",
	i18n: "TIMEZONE.NAIROBI",
	area: "",
	bc_id: "52",
	canonical_id: "Africa/Nairobi"
	},
	{
	gmt: "+03:00",
	city: "",
	country: "",
	continent: "Europe",
	location: "TIMEZONE.MOSCOW_ST_PETERSBURG_VOLGOGRAD",
	i18n: "TIMEZONE.MOSCOW_ST_PETERSBURG_VOLGOGRAD",
	area: "",
	bc_id: "51",
	canonical_id: "Europe/Moscow"
	},
	{
	gmt: "+03:30",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.TEHRAN",
	i18n: "TIMEZONE.TEHRAN",
	area: "",
	bc_id: "54",
	canonical_id: "Asia/Tehran"
	},
	{
	gmt: "+04:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.ABU_DHABI_MUSCAT",
	i18n: "TIMEZONE.ABU_DHABI_MUSCAT",
	area: "",
	bc_id: "55",
	canonical_id: "Asia/Muscat"
	},
	{
	gmt: "+04:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.BAKU",
	i18n: "TIMEZONE.BAKU",
	area: "",
	bc_id: "56",
	canonical_id: "Asia/Baku"
	},
	{
	gmt: "+04:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.CAUCASUS_STANDARD_TIME",
	i18n: "TIMEZONE.CAUCASUS_STANDARD_TIME",
	area: "",
	bc_id: "57",
	canonical_id: "Etc/GMT-4"
	},
	{
	gmt: "+04:00",
	city: "",
	country: "",
	continent: "Indian",
	location: "TIMEZONE.PORT_LOUIS",
	i18n: "TIMEZONE.PORT_LOUIS",
	area: "",
	bc_id: "58",
	canonical_id: "Indian/Mahe"
	},
	{
	gmt: "+04:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.YEREVAN",
	i18n: "TIMEZONE.YEREVAN",
	area: "",
	bc_id: "59",
	canonical_id: "Asia/Yerevan"
	},
	{
	gmt: "+04:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.TBILISI",
	i18n: "TIMEZONE.TBILISI",
	area: "",
	bc_id: "53",
	canonical_id: "Asia/Tbilisi"
	},
	{
	gmt: "+04:30",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.KABUL",
	i18n: "TIMEZONE.KABUL",
	area: "",
	bc_id: "60",
	canonical_id: "Asia/Kabul"
	},
	{
	gmt: "+05:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.ISLAMABAD_KARACHI",
	i18n: "TIMEZONE.ISLAMABAD_KARACHI",
	area: "",
	bc_id: "62",
	canonical_id: "Asia/Karachi"
	},
	{
	gmt: "+05:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.TASHKENT",
	i18n: "TIMEZONE.TASHKENT",
	area: "",
	bc_id: "63",
	canonical_id: "Asia/Tashkent"
	},
	{
	gmt: "+05:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.EKATERINBURG",
	i18n: "TIMEZONE.EKATERINBURG",
	area: "",
	bc_id: "61",
	canonical_id: "Asia/Yekaterinburg"
	},
	{
	gmt: "+05:30",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.CHENNAI_KOLKATA_MUMBAI_NEW_DELHI",
	i18n: "TIMEZONE.CHENNAI_KOLKATA_MUMBAI_NEW_DELHI",
	area: "",
	bc_id: "64",
	canonical_id: "Asia/Kolkata"
	},
	{
	gmt: "+05:30",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.SRI_JAYAWARDENEPURA",
	i18n: "TIMEZONE.SRI_JAYAWARDENEPURA",
	area: "",
	bc_id: "65",
	canonical_id: "Asia/Kolkata"
	},
	{
	gmt: "+05:45",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.KATHMANDU",
	i18n: "TIMEZONE.KATHMANDU",
	area: "",
	bc_id: "66",
	canonical_id: "Asia/Kathmandu"
	},
	{
	gmt: "+06:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.ALMATY",
	i18n: "TIMEZONE.ALMATY",
	area: "",
	bc_id: "67",
	canonical_id: "Asia/Almaty"
	},
	{
	gmt: "+06:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.ASTANA_DHAKA",
	i18n: "TIMEZONE.ASTANA_DHAKA",
	area: "",
	bc_id: "68",
	canonical_id: "Asia/Dhaka"
	},
	{
	gmt: "+06:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.NOVOSIBIRSK",
	i18n: "TIMEZONE.NOVOSIBIRSK",
	area: "",
	bc_id: "26",
	canonical_id: "Asia/Novosibirsk"
	},
	{
	gmt: "+06:30",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.YANGON",
	i18n: "TIMEZONE.YANGON",
	area: "",
	bc_id: "69",
	canonical_id: "Asia/Rangoon"
	},
	{
	gmt: "+07:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.BANGKOK_HANOI_JAKARTA",
	i18n: "TIMEZONE.BANGKOK_HANOI_JAKARTA",
	area: "",
	bc_id: "70",
	canonical_id: "Asia/Bangkok"
	},
	{
	gmt: "+07:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.KRASNOYARSK",
	i18n: "TIMEZONE.KRASNOYARSK",
	area: "",
	bc_id: "71",
	canonical_id: "Asia/Krasnoyarsk"
	},
	{
	gmt: "+08:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.BEIJING_CHONGQING_HONG_KONG_URUMQI",
	i18n: "TIMEZONE.BEIJING_CHONGQING_HONG_KONG_URUMQI",
	area: "",
	bc_id: "72",
	canonical_id: "Asia/Hong_Kong"
	},
	{
	gmt: "+08:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.ULAAN_BATAAR",
	i18n: "TIMEZONE.ULAAN_BATAAR",
	area: "",
	bc_id: "73",
	canonical_id: "Asia/Ulaanbaatar"
	},
	{
	gmt: "+08:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.KUALA_LUMPUR_SINGAPORE",
	i18n: "TIMEZONE.KUALA_LUMPUR_SINGAPORE",
	area: "",
	bc_id: "74",
	canonical_id: "Asia/Kuala_Lumpur"
	},
	{
	gmt: "+08:00",
	city: "",
	country: "",
	continent: "Australia",
	location: "TIMEZONE.PERTH",
	i18n: "TIMEZONE.PERTH",
	area: "",
	bc_id: "75",
	canonical_id: "Australia/Perth"
	},
	{
	gmt: "+08:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.TAIPEI",
	i18n: "TIMEZONE.TAIPEI",
	area: "",
	bc_id: "76",
	canonical_id: "Asia/Taipei"
	},
	{
	gmt: "+09:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.IRKUTSK",
	i18n: "TIMEZONE.IRKUTSK",
	area: "",
	bc_id: "92",
	canonical_id: "Asia/Irkutsk"
	},
	{
	gmt: "+09:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.OSAKA_SAPPORO_TOKYO",
	i18n: "TIMEZONE.OSAKA_SAPPORO_TOKYO",
	area: "",
	bc_id: "77",
	canonical_id: "Asia/Tokyo"
	},
	{
	gmt: "+09:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.SEOUL",
	i18n: "TIMEZONE.SEOUL",
	area: "",
	bc_id: "78",
	canonical_id: "Asia/Seoul"
	},
	{
	gmt: "+09:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.YAKUTSK",
	i18n: "TIMEZONE.YAKUTSK",
	area: "",
	bc_id: "79",
	canonical_id: "Asia/Yakutsk"
	},
	{
	gmt: "+09:30",
	city: "",
	country: "",
	continent: "Australia",
	location: "TIMEZONE.ADELAIDE",
	i18n: "TIMEZONE.ADELAIDE",
	area: "",
	bc_id: "80",
	canonical_id: "Australia/Adelaide"
	},
	{
	gmt: "+09:30",
	city: "",
	country: "",
	continent: "Australia",
	location: "TIMEZONE.DARWIN",
	i18n: "TIMEZONE.DARWIN",
	area: "",
	bc_id: "81",
	canonical_id: "Australia/Darwin"
	},
	{
	gmt: "+10:00",
	city: "",
	country: "",
	continent: "Australia",
	location: "TIMEZONE.CANBERRA_MELBOURNE_SYDNEY",
	i18n: "TIMEZONE.CANBERRA_MELBOURNE_SYDNEY",
	area: "",
	bc_id: "83",
	canonical_id: "Australia/Sydney"
	},
	{
	gmt: "+10:00",
	city: "",
	country: "",
	continent: "Australia",
	location: "TIMEZONE.BRISBANE",
	i18n: "TIMEZONE.BRISBANE",
	area: "",
	bc_id: "82",
	canonical_id: "Australia/Brisbane"
	},
	{
	gmt: "+10:00",
	city: "",
	country: "",
	continent: "Pacific",
	location: "TIMEZONE.GUAM_PORT_MORESBY",
	i18n: "TIMEZONE.GUAM_PORT_MORESBY",
	area: "",
	bc_id: "84",
	canonical_id: "Pacific/Port_Moresby"
	},
	{
	gmt: "+10:00",
	city: "",
	country: "",
	continent: "Australia",
	location: "TIMEZONE.HOBART",
	i18n: "TIMEZONE.HOBART",
	area: "",
	bc_id: "85",
	canonical_id: "Australia/Hobart"
	},
	{
	gmt: "+10:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.VLADIVOSTOK",
	i18n: "TIMEZONE.VLADIVOSTOK",
	area: "",
	bc_id: "86",
	canonical_id: "Asia/Vladivostok"
	},
	{
	gmt: "+11:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.SOLOMON_IS_NEW_CALEDONIA",
	i18n: "TIMEZONE.SOLOMON_IS_NEW_CALEDONIA",
	area: "",
	bc_id: "87",
	canonical_id: "Etc/GMT-11"
	},
	{
	gmt: "+11:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.MAGADAN",
	i18n: "TIMEZONE.MAGADAN",
	area: "",
	bc_id: "93",
	canonical_id: "Asia/Magadan"
	},
	{
	gmt: "+12:00",
	city: "",
	country: "",
	continent: "Pacific",
	location: "TIMEZONE.AUCKLAND_WELLINGTON",
	i18n: "TIMEZONE.AUCKLAND_WELLINGTON",
	area: "",
	bc_id: "88",
	canonical_id: "Pacific/Auckland"
	},
	{
	gmt: "+12:00",
	city: "",
	country: "",
	continent: "Asia",
	location: "TIMEZONE.FIJI_KAMCHATKA_MARSHALL_IS",
	i18n: "TIMEZONE.FIJI_KAMCHATKA_MARSHALL_IS",
	area: "",
	bc_id: "89",
	canonical_id: "Pacific/Fiji"
	},
	{
	gmt: "+13:00",
	city: "",
	country: "",
	continent: "Pacific",
	location: "TIMEZONE.NUKUALOFA",
	i18n: "TIMEZONE.NUKUALOFA",
	area: "",
	bc_id: "90",
	canonical_id: "Etc/GMT-13"
	},
	{
	gmt: "+13:00",
	city: "",
	country: "",
	continent: "Pacific",
	location: "TIMEZONE.SAMOA",
	i18n: "TIMEZONE.SAMOA",
	area: "",
	bc_id: "91",
	canonical_id: "Etc/GMT-13"
	}
]